import React, { Component } from 'react'
import { Link } from 'react-router'
import LinkDropdown from '../../../Buttons/linkDropdown/'
import { Button, ButtonToolbar, DropdownButton, MenuItem }from 'react-bootstrap'
import { translate } from "react-translate"

@translate("ActionBar")
export default class ActionBar extends Component {
  render () {

  	const {
      onClickViewGallery,
      onClickViewList,
      onClickViewMap,
      listType,
      onChangeCantElements,
      onChangeOrder,
      cantElements,
      originPath,
      originOffice,
      property_type,
      order,
			t
    } = this.props;

    var landing = ''
    let path = ''
    let options = []

    if (originPath.name == '/'){
    	landing = 'Home'
      path = '/'
    }
    else{
      landing = originPath.name
      path = '/' + (originPath.name).toLowerCase()
    }

    let oolc = (originOffice.name).toLowerCase()
    if ((oolc == 'puertos') || (oolc == 'nordelta') || (oolc == 'recoleta') || (oolc == 'palermo')) {
      path = "/sucursal/" + oolc
      landing = originOffice.name
    }
    else if (oolc == 'lomas de san isidro' || oolc == 'sanisidro'){
      path = "/sucursal/sanisidro"
      landing = originOffice.name
    }

    if ( originPath.name == "/"){
      if (property_type.length > 0){
        switch (property_type[0].name) {
          case 'Campo' :
            options = [{id: "max_price" , name: "Mayor Precio"}, {id: "min_price" , name: "Menor Precio"}, {id: "max_area" , name:  "Mayor Hectárea"},{id: "min_area" , name:  "Menor Hectárea"},{id: "outstanding" , name:  "Destacado"},{id: "aptitude" , name:  "Aptitud"},{id: "province" , name:  "Provincia"}]
            break;
          case 'Hotel' :
            options = [{id: "max_area" , name:  "Mayor M2"},{id: "min_area" , name:  "Menor M2"}, {id: "min_rating" , name:  "Estrellas ASC"} , {id: "max_rating" , name:  "Estrellas DESC"}, {id: "min_rooms" , name:  "Cant. Habitaciones ASC"}, {id: "max_rooms" , name:  "Cant. Habitaciones DESC"}, {id: "min_city" , name:  "Ciudad ASC"}, {id: "max_city" , name:  "Ciudad DESC"}]
            break;
          default:
            options = [{id: "max_price" , name: "Mayor Precio"}, {id: "min_price" , name: "Menor Precio"}, {id: "max_area" , name:  "Mayor M2"},{id: "min_area" , name:  "Menor M2"},{id: "relevance" , name:  "Relevancia"}]
        }
      }
      else{
        options = [{id: "max_price" , name: "Mayor Precio"}, {id: "min_price" , name: "Menor Precio"}, {id: "max_area" , name:  "Mayor M2"},{id: "min_area" , name:  "Menor M2"},{id: "relevance" , name:  "Relevancia"}]
      }

    }
    else{
      switch (originPath.name) {
        case 'Campos' :
          options = [{id: "max_price" , name: "Mayor Precio"}, {id: "min_price" , name: "Menor Precio"}, {id: "max_area" , name:  "Mayor Hectárea"},{id: "min_area" , name:  "Menor Hectárea"},{id: "outstanding" , name:  "Destacado"},{id: "aptitude" , name:  "Aptitud"},{id: "province" , name:  "Provincia"}]
          break;
        case 'Hoteles' :
          options = [{id: "max_area" , name:  "Mayor M2"},{id: "min_area" , name:  "Menor M2"}, {id: "min_rating" , name:  "Estrellas ASC"} , {id: "max_rating" , name:  "Estrellas DESC"}, {id: "min_rooms" , name:  "Cant. Habitaciones ASC"}, {id: "max_rooms" , name:  "Cant. Habitaciones DESC"}, {id: "min_city" , name:  "Ciudad ASC"}, {id: "max_city" , name:  "Ciudad DESC"}]
          break;
        default:
          options = [{id: "max_price" , name: "Mayor Precio"}, {id: "min_price" , name: "Menor Precio"}, {id: "max_area" , name:  "Mayor M2"},{id: "min_area" , name:  "Menor M2"},{id: "relevance" , name:  "Relevancia"}]
      }
    }

    let order_title = order ? order.name : `${t("Ordenar_Por")}`
    return (
    	<div className={"action-bar" + (listType == 'map' ? ' hide-bar' : '')}>
    		<div className="bar-place hidden-xs">
          <Link to={path}><p>{landing}</p></Link>
          <p>></p>
	      </div>
    		<div className="bar-options">
          <div className="dropdown-order">
            <DropdownButton title={order_title} id="dropdown-order" onSelect={ onChangeOrder }>
              {options.map((item, index) =>
                <MenuItem className="div-option" eventKey={item} key={index}>{item.name}</MenuItem>
              )}
            </DropdownButton>

          </div>
	        <div className="box-pages hidden-xs">
	        	<p>{t("Propiedad_Por_Pagina")}:</p>
	        	<ButtonToolbar>
	        		<Button bsStyle="link" className={(cantElements == 40 ? 'active-list' : '')} onClick={() => onChangeCantElements(40)}>40</Button>
	        		<Button bsStyle="link" className={(cantElements == 80 ? 'active-list' : '')} onClick={() => onChangeCantElements(80)}>80</Button>
	        		<Button bsStyle="link" className={(cantElements ==  120 ? 'active-list' : '')} onClick={() => onChangeCantElements(120)}>120</Button>
	  				</ButtonToolbar>
	        </div>
	        <div className="box-views hidden-xs">
	        	<Button bsStyle="link" onClick={onClickViewGallery} className={(listType == 'gallery' ? 'active-list' : '')}>
	        		<i className={"fa fa-th-large" + (listType == 'gallery' ? ' active-list' : '')}></i>
	        		{t("Ver_Galeria")}
        		</Button>
	        	<Button bsStyle="link" onClick={onClickViewList} className={(listType == 'list' ? 'active-list' : '')}>
        			<i className={"fa fa-bars" + (listType == 'list' ? ' active-list' : '')}></i>
      				{t("Ver_Lista")}
    				</Button>
	        	<Button bsStyle="link" onClick={onClickViewMap} className={(listType == 'map' ? 'active-list' : '')}>
	        		<i className={"fa fa-map-marker" + (listType == 'map' ? ' active-list' : '')}></i>
	        		{t("Ver_Mapa")}
        		</Button>
	        </div>
	      </div>
	      <div className="bar-divisor hidden-xs">
	      </div>
    	</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/Propiedades/ActionBar/index.js